
export default {
  name: 'CustomInput',
  props: {
    optional: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      value: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    maxLength: {
      type: Number,
      default: 256,
    },
    rules: {
      type: String,
      default: ''
    },
    labelDescription: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      default: ''
    }
  }
}
